import React from 'react';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import './CasePaginationControls.scss';

export const CasePaginationControls = ({ 
  currentIndex, 
  totalCases, 
  onPrev, 
  onNext,
  isLoading 
}) => {
  
  const showPrev = currentIndex > 0;
  const showNext = currentIndex < totalCases - 1 && currentIndex !== -1;
  const displayIndex = currentIndex + 1;

  
  if (totalCases === 0) {
    console.log('No cases available, hiding controls');
    return null;
  }

  return (
    <div className="case-pagination-controls">
      <button 
        className="pagination-arrow" 
        onClick={onPrev}
        disabled={!showPrev || currentIndex === -1}
        style={{ visibility: showPrev ? 'visible' : 'hidden' }}
        title="Previous Case"
      >
        <FiChevronLeft size={20} />
      </button>
      
      <div className="pagination-display">
        <span className="current-index">
          {currentIndex === -1 ? '?' : displayIndex}
        </span>
        <span className="separator">of</span>
        <span className="total-cases">{totalCases} cases</span>
      </div>
      
      <button 
        className="pagination-arrow" 
        onClick={onNext}
        disabled={!showNext || currentIndex === -1}
        style={{ visibility: showNext ? 'visible' : 'hidden' }}
        title="Next Case"
      >
        <FiChevronRight size={20} />
      </button>
    </div>
  );
};